import styled, { css } from 'styled-components'
import { theme, palette, ifProp } from 'styled-tools';
import { SpaceDiv } from 'components';

export const TabNavigation = styled.div`
    position: relative;
`;

export const TabContainer = styled.div`
    display: flex;
`;

interface TapWarpperProps {
    active: boolean;
}

export const TapWarpper = styled.div<TapWarpperProps>`
    padding: 16px 0;
    
    color: ${ifProp('active', palette('blue_900'), palette('gray_opacity_400'))};
    ${props => props.active ? css`border-bottom: 2px solid ${palette('blue_900')};` : null}

    &:not(:first-child) {
        margin-left: 24px;
    }
`;

export const TabLabel = styled.label`
    cursor: pointer;
    ${theme('fontStyle.subtitle_bold')}
`;

export const BorderLine = styled(SpaceDiv)`
    position: absolute;
    bottom: 0;
`;